import useStrings from "../../../localization/useStrings"
import images from "../../../utils/images"
import SimplePaywallStep from "../SimplePaywallStep/SimplePaywallStep"
import styles from "./ReminderPaywallStep.module.scss"

const ReminderPaywallStep = () => {
  const strings = useStrings().multistep.subtitleReminder

  return (
    <SimplePaywallStep>
      <div className={styles.container}>
        <div className={`${styles.image} ${images.multistep.ring.class}`} />
        <label className={styles.title}>
          {strings.line1}
          <label className={styles.titleAlt}>{strings.line2}</label>
          <label className={styles.title}>{strings.line3}</label>
        </label>
      </div>
    </SimplePaywallStep>
  )
}

export default ReminderPaywallStep
